{
    "tapi_integration__no_phone": "Aucun numéro de téléphone fourni",
    "tapi_integration__usage": "Utilisation : /integrations/tapi/[numéro-de-téléphone]",
    "tapi_integration__error": "Erreur lors de la recherche du numéro de téléphone",
    "tapi_integration__looking_up": "Recherche du numéro de téléphone",
    "tapi_integration__no_match": "Aucun client trouvé pour le numéro de téléphone :",
    "tapi_integration__no_match_help": "Le numéro de téléphone n'est peut-être pas enregistré dans le système, ou son format ne correspond pas."
}
